import { formatCurrencyInt } from '@edge/spark/utils'
import type { SearchVehicle } from '../types'

export const saleAmount = ({ saleAmount: _saleAmount }: SearchVehicle): string => formatCurrencyInt(_saleAmount) || '--'

/** @deprecated use saleAmount */
export const currency = saleAmount
